import { HotTub } from '@mui/icons-material'
import { ApplianceConfigBoiler } from './Appliance'
import { StrategySliders } from '../../components/StrategySliders'
import { TemperatureRelayAppliance } from './TemperatureRelayAppliance'

export class BoilerAppliance extends TemperatureRelayAppliance<ApplianceConfigBoiler> {

  get Icon() {
    return HotTub
  }

  getDefaultConfig(): ApplianceConfigBoiler {
    return Object.assign({
      advanced: false,
      strategy: 'MANUAL',
      plan_by_price: true,
      pv_priority: 4,
      saving_or_heat: 0,
      heat_preservation: 8,
      volume: 180,
      people: 4,
      fixed_percentage: 40,
    }, super.getDefaultConfig())
  }

  drawSliders(): React.ReactNode {

    return (
      <StrategySliders
        name1="volume"
        slider1={['50l', '500l']}
        values1={[50, 500]}
        value1={this.getConfig('volume')}
        title1={this.app.t('Volume')}

        name2="people"
        slider2={['🧍', '🧍x 10']}
        values2={[1, 10]}
        value2={this.getConfig('people')}
        title2={this.app.t('Number of People')}

        onChange={(k, v) => { this.setConfig(k, v); this.applyConfig() }}
      />
    )
  }

  convert() {
    const ctrl = this.getOptimizerControl()
    const advanced = this.getConfig('advanced')

    return Object.assign({
      min_duty: advanced ? ctrl.getConfig('min_duty') : 5 + 5 * (this.getConfig('people') as number),
      max_duty: advanced ? ctrl.getConfig('max_duty') : 5 + 5 * (this.getConfig('people') as number),
      min_duty_at: advanced ? ctrl.getConfig('min_duty_at') : 0,
      max_duty_at: advanced ? ctrl.getConfig('max_duty_at') : 0,
      time_constant: advanced ? this.getConfig('heat_preservation') : Math.min(24, Math.max(4, Math.round((this.getConfig('volume') as number) / (this.getConfig('people') as number * 2)))),
    }, super.convert())
  }
}
